import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.renewIfExpiringSoon();

  if (authService.isLoggedIn() && !(await authService.isTokenExpired())) {
    authService.fetchUserProfile(0, true).subscribe();
    return true;
  }
  router.navigate(['/login']);
  return false;
};